export const MAX_PHOTOS_PER_UPLOAD = 5;
export const MAX_PHOTO_SIZE_MB = 10;
export const MAX_AVATAR_SIZE_MB = 5;
export const MAX_PHOTO_SIZE = MAX_PHOTO_SIZE_MB * 1024 * 1024;
export const MAX_AVATAR_SIZE = MAX_AVATAR_SIZE_MB * 1024 * 1024;
export const PHOTO_UPLOAD_ACCEPT = "image/jpeg,image/png";
export const CSV_UPLOAD_ACCEPT = ".csv,text/csv";

const ALLOWED_PHOTO_TYPES = new Set(["image/jpeg", "image/png"]);
const ALLOWED_CSV_TYPES = new Set([
    "text/csv",
    "text/plain",
    "application/csv",
    "application/x-csv",
    "text/x-csv",
    "text/comma-separated-values",
    "application/vnd.ms-excel",
    "application/octet-stream",
]);

export const PHOTO_LABELS = {
    place: "Фото места",
    catch: "Фото улова",
    depth: "Фото эхолота",
};

function hasAllowedPhotoExtension(file) {
    return /\.(jpe?g|png)$/i.test(file?.name || "");
}

function hasCsvExtension(file) {
    return /\.csv$/i.test(file?.name || "");
}

export function validatePhotoSelection(type, fileList) {
    const selectedFiles = Array.from(fileList || []);
    const label = PHOTO_LABELS[type] || "Фото";
    const errors = [];
    const validFiles = [];

    if (selectedFiles.length > MAX_PHOTOS_PER_UPLOAD) {
        errors.push(`${label}: можно выбрать не больше ${MAX_PHOTOS_PER_UPLOAD} файлов.`);
    }

    selectedFiles.slice(0, MAX_PHOTOS_PER_UPLOAD).forEach((file) => {
        const fileType = String(file?.type || "").toLowerCase();
        if (!ALLOWED_PHOTO_TYPES.has(fileType) || !hasAllowedPhotoExtension(file)) {
            errors.push(`${label}: "${file.name}" должен быть JPG или PNG.`);
            return;
        }
        if (file.size > MAX_PHOTO_SIZE) {
            errors.push(`${label}: "${file.name}" больше ${MAX_PHOTO_SIZE_MB} МБ.`);
            return;
        }
        validFiles.push(file);
    });

    return { files: validFiles, error: errors.join(" ") };
}

export function validateAvatarFile(file) {
    if (!file) {
        return { file: null, error: "Выберите изображение." };
    }

    const fileType = String(file.type || "").toLowerCase();
    if (!ALLOWED_PHOTO_TYPES.has(fileType) || !hasAllowedPhotoExtension(file)) {
        return { file: null, error: "Аватар должен быть JPG или PNG." };
    }
    if (file.size > MAX_AVATAR_SIZE) {
        return { file: null, error: `Файл больше ${MAX_AVATAR_SIZE_MB} МБ.` };
    }

    return { file, error: "" };
}

export function getCsvFileError(file) {
    if (!file) {
        return "Выберите CSV файл.";
    }

    const fileType = String(file.type || "").toLowerCase();
    if (!hasCsvExtension(file) || !ALLOWED_CSV_TYPES.has(fileType)) {
        return "Можно загрузить только CSV файл.";
    }

    return "";
}
